import React from "react";
import {Col, Container, Row, Visible} from "react-awesome-styled-grid";
import {FlexContainer} from "../../design";

type Props = {
  left: Node,
  right: Node
}

const BaseSplitPage = (props: Props) => {
  return (
    <Container style={{padding: 0, margin:0, height: '100vh'}}  fluid>
      <Row style={{height: '100%', margin:0}} noGutter>
          <Visible md lg xl className="h-100">
            <Col className="h-100" md={3} lg={4} noGutter>
            <FlexContainer style={{position: "fixed", overflowX:"hidden", overflowY: "auto", maxWidth:"inherit", width: "100%", height: "100%"}}>
              <Row className="h-100">
                <Col md={1} lg={2} className="h-100"/>
                <Col md={6} lg={7} xl={7} className="h-100">
                  <FlexContainer className="h-100" flexDirection="column" position="relative"  marginTop="2.5rem">
                    {props.left}
                  </FlexContainer>
                </Col>
              </Row>
            </FlexContainer>
            </Col>
          </Visible>
        <Col md={5} lg={8} xs={12} noGutter style={{backgroundColor:"white", boxShadow: "0 0 15px 0 rgba(0, 0, 0, 0.1)"}}>
          <Container className="px-0 px-md-5 px-lg-0">
            <Row className="pt-0 pt-md-4 mt-0 mt-md-2 px-3 px-md-5 mx-0">
              <Col align={{xs: 'center', sm: 'center', md: 'flex-start', lg: 'flex-start'}} noGutter className="px-0 px-lg-4">
                {props.right}
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
    </Container>
  )
};

export default BaseSplitPage;
